import React, { useEffect, useState } from "react";
import "../Styles/Roles.css";
import { Box } from "@mui/system";
import { 
  MenuItem, 
  Select, 
  TextField, 
  FormControl, 
  InputLabel, 
  OutlinedInput, 
  Chip 
} from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function RolesDetails({
  edit,
  roles,
  isNew,
  empData,
  setEmpData,
  teamNames,
  teamsData,
  errors,
}) {
  const [selectedRole, setSelectedRole] = useState(empData[0]?.DRM_ID);
  const [selectedDesignation, setSelectedDesignation] = useState(
    empData[0]?.EM_Designation
  );
  const [selectedTeam, setSelectedTeam] = useState(empData[0]?.STM_Team);
  const [selectedSubTeam, setSelectedSubTeam] = useState(
    empData[0]?.STM_Subteam
  );
  
  const editMode = isNew ? true : edit;

  const handleRoleChange = (event) => {
    const value = event.target.value;
    setSelectedRole(value);
    
    // Update parent state with single value for compatibility
    const updatedEmpData = {
      ...empData,
      0: {
        ...empData["0"],
        DRM_ID: value,
      },
    };
    setEmpData(updatedEmpData);
  };

  return (
    <div className="Roles_layout">
      <div className="Roles_row_fiels">
        <div className="Roles_row">
          <div className="Roles_row__label">
            Designation <span className="span-icon-star">*</span>
          </div>
          <div className="select_box_Detail">
            <Box sx={{ minWidth: 600 }}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  select
                  className="textfield_organisation_deatils1"
                  disabled={!editMode}
                  value={selectedDesignation || ""}
                  onChange={(e) => {
                    setSelectedDesignation(e.target.value);
                    const updatedEmpData = {
                      ...empData,
                      0: {
                        ...empData["0"],
                        EM_Designation: parseInt(e.target.value, 10),
                      },
                    };
                    setEmpData(updatedEmpData);
                  }}
                >
                  {roles
                    ?.filter((role) => role.Type !== "R")
                    .map((data) => (
                      <MenuItem key={data.Id} value={data.Id}>
                        {data.Name}
                      </MenuItem>
                    ))}
                </TextField>
              </FormControl>
            </Box>
          </div>
          {!selectedDesignation && errors && (
            <div style={{ color: "red" }}>Designation is required</div>
          )}
        </div>

        <div className="Roles_row">
          <div className="Roles_row__label">
            Role <span className="span-icon-star">*</span>
          </div>
          <div className="select_box_Detail">
            <Box sx={{ minWidth: 600 }}>
              <FormControl fullWidth>
                <TextField
                  select
                  className="textfield_organisation_deatils1"
                  fullWidth
                  disabled={!editMode}
                  value={selectedRole || ""}
                  onChange={handleRoleChange}
                >
                  {roles
                    ?.filter((role) => role.Type === "R")
                    .map((data) => (
                      <MenuItem key={data.Id} value={data.Id}>
                        {data.Name}
                      </MenuItem>
                    ))}
                </TextField>
              </FormControl>
            </Box>
            {!selectedRole && errors && (
              <div style={{ color: "red" }}>Role is required</div>
            )}
          </div>
        </div>
      </div>

      <div className="Roles_row_fiels">
        <div className="Roles_row">
          <div className="Roles_row__label">
            Team <span className="span-icon-star">*</span>
          </div>
          <div className="select_box_Detail">
            <Box sx={{ minWidth: 600 }}>
              <FormControl fullWidth>
                <TextField
                  select
                  className="textfield_organisation_deatils1"
                  fullWidth
                  disabled={!editMode}
                  value={selectedTeam || ""}
                  onChange={(e) => {
                    setSelectedTeam(e.target.value);
                    const updatedEmpData = {
                      ...empData,
                      0: {
                        ...empData["0"],
                        STM_Team: e.target.value,
                        STM_Subteam: "",
                      },
                    };
                    setEmpData(updatedEmpData);
                  }}
                >
                  {teamsData[0]
                    ?.filter(
                      (team) => team?.status === true && team?.type === "T"
                    )
                    ?.map((data) => (
                      <MenuItem key={data.id} value={data.id}>{data.name}</MenuItem>
                    ))}
                </TextField>
              </FormControl>
            </Box>
            {!selectedTeam && errors && (
              <div style={{ color: "red" }}>Team is required</div>
            )}
          </div>
        </div>

        <div className="Roles_row">
          <div className="Roles_row__label">
            Sub Team <span className="span-icon-star">*</span>
          </div>
          <div className="select_box_Detail">
            <Box sx={{ minWidth: 600 }}>
              <FormControl fullWidth>
                <TextField
                  select
                  className="textfield_organisation_deatils1"
                  fullWidth
                  disabled={!editMode}
                  value={selectedSubTeam || ""}
                  onChange={(e) => {
                    setSelectedSubTeam(e.target.value);
                    const updatedEmpData = {
                      ...empData,
                      0: {
                        ...empData["0"],
                        STM_Subteam: e.target.value,
                      },
                    };
                    setEmpData(updatedEmpData);
                  }}
                >
                  {teamsData[0]
                    ?.filter(
                      (team) =>
                        team.superTeamId === parseFloat(selectedTeam) &&
                        team.status === true
                    )
                    ?.map((data) => (
                      <MenuItem key={data.id} value={data.id}>{data.name}</MenuItem>
                    ))}
                </TextField>
              </FormControl>
            </Box>
            {!selectedSubTeam && errors && (
              <div style={{ color: "red" }}>Sub Team is required</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RolesDetails;
